import React from 'react';

/**
 * ConfirmationModal - A brand-themed confirmation modal.
 * 
 * Props:
 * - isOpen: boolean - whether to show the modal
 * - title: string - modal title
 * - message: string | React.ReactNode - main message (can include line breaks or JSX)
 * - confirmText: string - text for confirm button (default: "Confirm")
 * - cancelText: string - text for cancel button (default: "Cancel")
 * - onConfirm: function - callback when confirm is clicked
 * - onCancel: function - callback when cancel is clicked or overlay clicked
 * - confirmStyle: 'primary' | 'danger' - optional styling for confirm button
 */
export const ConfirmationModal = ({
    isOpen,
    title,
    message,
    confirmText = 'Confirm',
    cancelText = 'Cancel',
    onConfirm,
    onCancel,
    confirmStyle = 'primary'
}) => {
    if (!isOpen) return null;

    const confirmButtonClass = confirmStyle === 'danger'
        ? 'confirmation-modal__btn confirmation-modal__btn--danger'
        : 'confirmation-modal__btn confirmation-modal__btn--primary';

    return (
        <div className="confirmation-modal-overlay" onClick={onCancel}>
            <div className="confirmation-modal" onClick={(e) => e.stopPropagation()}>
                {title && <h2 className="confirmation-modal__title">{title}</h2>}
                <div className="confirmation-modal__message">
                    {typeof message === 'string' ? (
                        message.split('\n').map((line, i) => (
                            <p key={i}>{line}</p>
                        ))
                    ) : message}
                </div>
                <div className="confirmation-modal__actions">
                    <button
                        className="confirmation-modal__btn confirmation-modal__btn--secondary"
                        onClick={onCancel}
                    >
                        {cancelText}
                    </button>
                    <button
                        className={confirmButtonClass}
                        onClick={onConfirm}
                    >
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
};
